import { render, staticRenderFns } from "./PromotionsuebersichtModulunterricht.vue?vue&type=template&id=a22a7730&scoped=true"
import script from "./PromotionsuebersichtModulunterricht.vue?vue&type=script&lang=js"
export * from "./PromotionsuebersichtModulunterricht.vue?vue&type=script&lang=js"
import style0 from "./PromotionsuebersichtModulunterricht.vue?vue&type=style&index=0&id=a22a7730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22a7730",
  null
  
)

export default component.exports